import { vue } from "../../main.js";
import * as customsEntryRegistrationApi from "../../backend/customsEntryRegistrationApi.js";

const state = {
  route: null,
  routeNumber: "",
  state: 0,
  createdDate: null,
  forwarder: null,
  attachments: [],
  lables: [],
  routeEx: null,
  routeT1: null,
  routeTir: null,
  additionalExpenses: null,
  borderPassBlack: null,
  borderPassBlackCurrency: null,
  borderPassGreen: null,
  borderPassGreenCurrency: null,
  borderPassRegistration: null,
  borderPassRegistrationCurrency: null,
  borderPassStamp: null,
  borderPassStampCurrency: null,
  driver: null,
  loading: false,
  loadingDates: false,
  loadingExpedition: false,
  columnsSetting: null,
  columns: [],
  savedSettings: [],
  selectedSetting: null,
  items: [],
  ex: {
    exWhoDoing: {
      variants: [
        { id: 2, title: "Делает фабрика" },
        { id: 3, title: "Без документов" },
        { id: 4, title: "Т1" },
        { id: 5, title: "По инвойсу" },
        { id: 6, title: "Делает экспедиция" },
        { id: 7, title: "Делает склад" },
        { id: 8, title: "Неизвестно" },
      ],
    },
    exDocumentInSystem: {
      variants: [
        { id: 0, title: "Нет в системе", color: "red" },
        { id: 1, title: "Есть в системе", color: "green" },
      ],
    },
  },
  changedEntityInfo: null,
  customsManager: null,
};

const getters = {
  getRoute(state) {
    return state.route;
  },
  getRouteNumber(state) {
    return state.routeNumber;
  },
  getState(state) {
    return state.state;
  },
  getCreatedDate(state) {
    return state.createdDate;
  },
  getForwarder(state) {
    return state.forwarder;
  },
  getAttachments(state) {
    return state.attachments;
  },
  getLables(state) {
    return state.lables;
  },
  getRouteEx(state) {
    return state.routeEx;
  },
  getRouteT1(state) {
    return state.routeT1;
  },
  getRouteTir(state) {
    return state.routeTir;
  },
  getAdditionalExpenses(state) {
    return state.additionalExpenses;
  },
  getBorderPassBlack(state) {
    return state.borderPassBlack;
  },
  getBorderPassBlackCurrency(state) {
    return state.borderPassBlackCurrency;
  },
  getBorderPassGreen(state) {
    return state.borderPassGreen;
  },
  getBorderPassGreenCurrency(state) {
    return state.borderPassGreenCurrency;
  },
  getBorderPassRegistration(state) {
    return state.borderPassRegistration;
  },
  getBorderPassRegistrationCurrency(state) {
    return state.borderPassRegistrationCurrency;
  },
  getBorderPassStamp(state) {
    return state.borderPassStamp;
  },
  getBorderPassStampCurrency(state) {
    return state.borderPassStampCurrency;
  },
  getDriver(state) {
    return state.driver;
  },
  getLoading(state) {
    return state.loading;
  },
  getLoadingDates(state) {
    return state.loadingDates;
  },
  getLoadingExpedition(state) {
    return state.loadingExpedition;
  },
  columnsSetting(state) {
    return state.columnsSetting;
  },
  savedSettings(state) {
    return state.savedSettings;
  },
  items(state) {
    return state.items;
  },
  ex(state) {
    return state.ex;
  },
  columns(state) {
    return state.columns;
  },
  selectedSetting(state) {
    return state.selectedSetting;
  },
  changedEntityInfo(state) {
    return state.changedEntityInfo;
  },
  customsManager(state) {
    return state.customsManager;
  },
};

const actions = {
  async getData({ commit, dispatch }, id) {
    commit("setLoading", true);
    const res = await customsEntryRegistrationApi.getData(id);
    commit("setRoute", res.data);
    commit("setCreatedDate", vue.$options.filters.date(res.data.Date));
    commit("setRouteNumber", res.data.Number);
    commit(
      "setAttachments",
      res.data.Attachments.map(a => {
        return {
          id: a.Id,
          title: a.Title,
        };
      }),
    );
    commit("setState", {
      id: res.data.State.Id,
      title: res.data.State.Title,
    });
    commit(
      "setForwarder",
      res.data.Forwarder
        ? { id: res.data.Forwarder.Id, title: res.data.Forwarder.Title }
        : null,
    );
    commit("setLables", [
      { name: "driverHasPP", value: res.data.DriverHasPP },
      { name: "finalInvoice", value: res.data.FinalInvoice },
      { name: "financialPart", value: res.data.FinancialPart },
    ]);
    commit("setRouteEx", res.data.Ex === 0 ? null : res.data.Ex);
    commit("setRouteT1", res.data.T1 === 0 ? null : res.data.T1);
    commit("setRouteTir", res.data.Tir === 0 ? null : res.data.Tir);
    commit(
      "setAdditionalExpenses",
      res.data.AdditionalExpenses === 0 ? null : res.data.AdditionalExpenses,
    );
    commit(
      "setBorderPassBlack",
      res.data.BorderPassBlack.Value === 0
        ? null
        : res.data.BorderPassBlack.Value,
    );
    commit(
      "setBorderPassBlackCurrency",
      res.data.BorderPassBlack.Currency === null
        ? null
        : {
          id: res.data.BorderPassBlack.Currency.Id,
          title: res.data.BorderPassBlack.Currency.Title,
        },
    );
    commit(
      "setBorderPassGreen",
      res.data.BorderPassGreen.Value === 0
        ? null
        : res.data.BorderPassGreen.Value,
    );
    commit(
      "setBorderPassGreenCurrency",
      res.data.BorderPassGreen.Currency === null
        ? null
        : {
          id: res.data.BorderPassGreen.Currency.Id,
          title: res.data.BorderPassGreen.Currency.Title,
        },
    );
    commit(
      "setBorderPassRegistration",
      res.data.BorderPassRegistration.Value === 0
        ? null
        : res.data.BorderPassRegistration.Value,
    );
    commit(
      "setBorderPassRegistrationCurrency",
      res.data.BorderPassRegistration.Currency === null
        ? null
        : {
          id: res.data.BorderPassRegistration.Currency.Id,
          title: res.data.BorderPassRegistration.Currency.Title,
        },
    );
    commit(
      "setBorderPassStamp",
      res.data.BorderPassStamp.Value === 0
        ? null
        : res.data.BorderPassStamp.Value,
    );
    commit(
      "setBorderPassStampCurrency",
      res.data.BorderPassStamp.Currency === null
        ? null
        : {
          id: res.data.BorderPassStamp.Currency.Id,
          title: res.data.BorderPassStamp.Currency.Title,
        },
    );
    const driver = res.data.Driver
      ? {
        id: res.data.Driver.Id,
        title: res.data.Driver.Title,
      }
      : null;
    commit("setDriver", driver);
    const customsManager = res.data.CustomsManager
      ? {
        id: res.data.CustomsManager.Id,
        title: res.data.CustomsManager.Title,
      }
      : null;
    commit("setCustomsManager", customsManager);
    await dispatch("getItems", id);
    commit("setLoading", false);
  },
  async saveRoutePrefix({ getters }, id) {
    const prefix = getters.getRoute.RoutePrefix;
    await customsEntryRegistrationApi.updateRoutePrefix(id, prefix);
    vue.showInfo("Префикс сохранен");
  },
  async changeDates({ getters, commit }, id) {
    commit("setLoadingDates", true);

    const routeDates = {
      customsRegistrationDateFact: getters.getRoute.CustomsRegistrationDateFact,
      arriveToWarehouseDatePlan: getters.getRoute.ArriveToWarehouseDatePlan,
      arriveToWarehouseDateFact: getters.getRoute.ArriveToWarehouseDateFact,
      passingBorderDatePlan: getters.getRoute.PassingBorderDatePlan,
      passingBorderDateFact: getters.getRoute.PassingBorderDateFact,
    };

    await customsEntryRegistrationApi.updateRouteDates(id, routeDates);
    commit("setLoadingDates", false);
  },
  async updateForwarder({ commit }, params) {
    commit("setLoadingExpedition", true);
    await customsEntryRegistrationApi.updateForwarder(
      params.id,
      params.element?.id || params.element,
    );
    commit("setForwarder", params.element);
    commit("setLoadingExpedition", false);
  },
  async updateEx({ getters, commit }, id) {
    if (getters.getRouteEx) {
      commit("setLoadingExpedition", true);
      await customsEntryRegistrationApi.updateEx(id, getters.getRouteEx);
      commit("setLoadingExpedition", false);
    }
  },
  async updateT1({ getters, commit }, id) {
    if (getters.getRouteT1) {
      commit("setLoadingExpedition", true);
      await customsEntryRegistrationApi.updateT1(id, getters.getRouteT1);
      commit("setLoadingExpedition", false);
    }
  },
  async updateTir({ getters, commit }, id) {
    if (getters.getRouteTir) {
      commit("setLoadingExpedition", true);
      await customsEntryRegistrationApi.updateTir(id, getters.getRouteTir);
      commit("setLoadingExpedition", false);
    }
  },
  async updateAdditionalExpenses({ getters, commit }, id) {
    if (getters.getAdditionalExpenses) {
      commit("setLoadingExpedition", true);
      await customsEntryRegistrationApi.updateAdditionalExpenses(
        id,
        getters.getAdditionalExpenses,
      );
      commit("setLoadingExpedition", false);
    }
  },
  async changeBorderPassCost({ getters }, params) {
    let borderPassCost = null;
    switch (params.type) {
      case "black":
        borderPassCost = {
          value: getters.getBorderPassBlack,
          currencyId: getters.getBorderPassBlackCurrency
            ? getters.getBorderPassBlackCurrency.id
            : null,
          type: "black",
        };
        break;
      case "green":
        borderPassCost = {
          value: getters.getBorderPassGreen,
          currencyId: getters.getBorderPassGreenCurrency
            ? getters.getBorderPassGreenCurrency.id
            : null,
          type: "green",
        };
        break;
      case "registration":
        borderPassCost = {
          value: getters.getBorderPassRegistration,
          currencyId: getters.getBorderPassRegistrationCurrency
            ? getters.getBorderPassRegistrationCurrency.id
            : null,
          type: "registration",
        };
        break;
      case "stamp":
        borderPassCost = {
          value: getters.getBorderPassStamp,
          currencyId: getters.getBorderPassStampCurrency
            ? getters.getBorderPassStampCurrency.id
            : null,
          type: "stamp",
        };
        break;
    }

    await customsEntryRegistrationApi.updateBorderPassCost(
      params.id,
      borderPassCost,
    );
  },
  async getItems({ getters, commit }, id) {
    const res = await customsEntryRegistrationApi.getItems(id);
    res.forEach((i, index) => {
      i.Ex = {
        Author: i.Ex.Author,
        ExDocumentInSystem: getters.ex.exDocumentInSystem.variants.find(
          v => v.id === i.Ex.ExDocumentInSystem,
        ),
        ExWhoDoing: getters.ex.exWhoDoing.variants.find(
          v => v.id === i.Ex.ExWhoDoing,
        ),
      };
      if (i.InvoiceSum) {
        i.Cost =
          vue.$options.filters.separateDigits(
            i.InvoiceSum.toFixed(2).replace(".", ","),
          ) + ` ${i.Currency}`;
      }
      i.rowNumber = index + 1;
    });
    commit("setItems", res);
  },
};

const mutations = {
  setDirection(state, value) {
    state.direction = value;
  },
  setRoute(state, value) {
    return (state.route = value);
  },
  setRouteNumber(state, value) {
    return (state.routeNumber = value);
  },
  setState(state, value) {
    return (state.state = value);
  },
  setCreatedDate(state, value) {
    return (state.createdDate = value);
  },
  setForwarder(state, value) {
    return (state.forwarder = value);
  },
  setAttachments(state, value) {
    return (state.attachments = value);
  },
  setLables(state, value) {
    return (state.lables = value);
  },
  setRouteEx(state, value) {
    return (state.routeEx = value);
  },
  setRouteT1(state, value) {
    return (state.routeT1 = value);
  },
  setRouteTir(state, value) {
    return (state.routeTir = value);
  },
  setAdditionalExpenses(state, value) {
    return (state.additionalExpenses = value);
  },
  setBorderPassBlack(state, value) {
    return (state.borderPassBlack = value);
  },
  setBorderPassBlackCurrency(state, value) {
    return (state.borderPassBlackCurrency = value);
  },
  setBorderPassGreen(state, value) {
    return (state.borderPassGreen = value);
  },
  setBorderPassGreenCurrency(state, value) {
    return (state.borderPassGreenCurrency = value);
  },
  setBorderPassRegistration(state, value) {
    return (state.borderPassRegistration = value);
  },
  setBorderPassRegistrationCurrency(state, value) {
    return (state.borderPassRegistrationCurrency = value);
  },
  setBorderPassStamp(state, value) {
    return (state.borderPassStamp = value);
  },
  setBorderPassStampCurrency(state, value) {
    return (state.borderPassStampCurrency = value);
  },
  setDriver(state, value) {
    return (state.driver = value);
  },
  setLoading(state, value) {
    return (state.loading = value);
  },
  setLoadingDates(state, value) {
    return (state.loadingDates = value);
  },
  setLoadingExpedition(state, value) {
    return (state.loadingExpedition = value);
  },
  setColumnsSetting(state, columnsSetting) {
    state.columnsSetting = columnsSetting;
  },
  setSavedSettings(state, savedSettings) {
    state.savedSettings = savedSettings;
  },
  setItems(state, value) {
    state.items = value;
  },
  setColumns(state, columns) {
    state.columns = columns;
  },
  setSelectedSetting(state, value) {
    state.selectedSetting = value;
  },
  setChangedEntityInfo(state, value) {
    state.changedEntityInfo = value;
  },
  setCustomsManager(state, value) {
    return (state.customsManager = value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
